import construction from "@assets/images/home/our-sectors/construction.jpg";
import hvac from "@assets/images/home/our-sectors/hvac.jpg";
import insulation from "@assets/images/home/our-sectors/insulation.jpg";
import steel from "@assets/images/home/our-sectors/steel.jpg";

export interface SectorData {
  img: string;
  color: string;
  titleKey: string;
  descriptionKey: string;
  to: string;
}

export const sectorColors: SectorData[] = [
  {
    img: steel,
    color: "#F43400",
    titleKey: "ourSectors.steel.title",
    descriptionKey: "ourSectors.steel.description",
    to: "fabricated-sector",
  },
  {
    img: hvac,
    color: "#00C2E1",
    titleKey: "ourSectors.hvac.title",
    descriptionKey: "ourSectors.hvac.description",
    to: "air-conditioning-sector",
  },
  {
    img: insulation,
    color: "#9531B3",
    titleKey: "ourSectors.insulation.title",
    descriptionKey: "ourSectors.insulation.description",
    to: "insulation-sector",
  },
  {
    img: construction,
    color: "#FFB624",
    titleKey: "ourSectors.construction.title",
    descriptionKey: "ourSectors.construction.description",
    to: "construction-sector",
  },
];
